import { FC } from "react";
import Status from "../ui/Status";
import { OperatorInvoiceStatus } from "../../interfaces/endpoints/IOperatorInvoice";

const statusMeta: Record<
  OperatorInvoiceStatus,
  { name: string; type: "orange" | "green" | "red" }
> = {
  [OperatorInvoiceStatus.Generated]: { name: "Generated", type: "orange" },
  [OperatorInvoiceStatus.Sent]: { name: "Sent", type: "green" },
  [OperatorInvoiceStatus.Cancelled]: { name: "Cancelled", type: "red" }
};

const InvoiceStatusBadge: FC<{ status: OperatorInvoiceStatus }> = ({
  status
}) => {
  const meta = statusMeta[status] || { name: "Unknown", type: "orange" as const };
  return <Status name={meta.name} type={meta.type} />;
};

export default InvoiceStatusBadge;
